import React from "react";
import styles from "./styles.module.css";

const SKELETON_ROW_COUNT = 5;
const ROW_WIDTHS = ["100%", "92%", "97%", "88%", "95%"];

export default function PositionsTableSkeleton() {
  return (
    <div
      className={styles.skeletonContainer}
      role="status"
      aria-label="Loading positions"
    >
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => (
        <div key={i} className={styles.skeletonRow}>
          <div
            className={styles.skeletonBar}
            style={{ width: ROW_WIDTHS[i] }}
          />
        </div>
      ))}
    </div>
  );
}
